import React from "react";
import { UsersTable } from "./UsersTable";
export class UsersView extends React.Component {
    render() {
        return <UsersTable type={this.props.match.params.types} />;
    }
}
